import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
// import createLogger from 'vuex/dist/logger'

Vue.use(Vuex);

const state = {
  user: null,
  cartItems:
    window.localStorage.getItem("cartItems") == null
      ? []
      : JSON.parse(window.localStorage.getItem("cartItems"))
};

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  strict: debug
});
